<script>
export default {
  props: ["component", "handler"],

};
</script>
<template>
  <vue-placeholder
    :component="component.component"
    :handler="component.handler"
  ></vue-placeholder>
</template>